const post = (url, body = {}) => {
  return fetch(url, {
    method: 'post',
    headers: { 'Content-Type': "application/json" },
    body: JSON.stringify(body),
  });
}

export { post };
